import { type CreateOptions } from '@anycable/core'
import { type AlmanacCableSubscriptions, type AlmanacCable, type AlmanacCableConsumer } from './types'

import { DebugCable } from './DebugCable'
import { CableConnectionManager } from './CableConnectionManager'
import { DebugCableSubscriptions } from './DebugSubscriptions'

export class DebugActionCableConsumer implements AlmanacCableConsumer {
  cable: AlmanacCable
  subscriptions: AlmanacCableSubscriptions
  constructor(url: string, opts: Partial<CreateOptions>, fallbackUrl: string) {
    const realThing = new CableConnectionManager(url, fallbackUrl, opts)
    this.cable = new DebugCable(realThing)
    this.subscriptions = new DebugCableSubscriptions(realThing)
  }
}
